"use client";
import {
  TooltipContextProvider
} from "../__chunks/F4IYJ42G.js";
import "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import {
  useTooltipStore
} from "../__chunks/YTDK2NGG.js";
import "../__chunks/FTXTWCCT.js";
import "../__chunks/O2PQ2652.js";
import "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip-provider.tsx
import { jsx } from "react/jsx-runtime";
function TooltipProvider(props = {}) {
  const store = useTooltipStore(props);
  return /* @__PURE__ */ jsx(TooltipContextProvider, { value: store, children: props.children });
}
export {
  TooltipProvider
};
